import { Icon } from 'blaze-ui/icons/Types'
import {
  AlignCenter,
  AlignJustify,
  AlignLeft,
  AlignRight,
  ArrowRotateLeft2,
  BrowserCode,
  CheckList,
  Code4,
  ColumnVertical1,
  ColumnVertical2,
  ColumnVertical3,
  Edit3,
  Font,
  FontWeight,
  H1,
  H2,
  H3,
  CoverImage,
  Data,
  Divider,
  HighlightText,
  ImageAdd,
  IndentDecrease,
  IndentIncrease,
  LetterSpacing3,
  LinkAngled,
  List,
  ListNumbers,
  NormalText,
  Menu2,
  Plus,
  Table,
  TextColor,
  Title,
  ToggleBlock,
  Mention,
  AddElements,
} from 'blaze-ui/icons'

export enum IconName {
  NormalText = 'NormalText',
  Title = 'Title',
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  Edit = 'Edit',
  List = 'List',
  Reset = 'Reset',
  Font = 'Font',
  FontWeight = 'FontWeight',
  FontSize = 'FontSize',
  ListNumbers = 'ListNumbers',
  CheckList = 'CheckList',
  ToggleBlock = 'ToggleBlock',
  AlignLeft = 'AlignLeft',
  AlignRight = 'AlignRight',
  AlignCenter = 'AlignCenter',
  AlignJustify = 'AlignJustify',
  TextColor = 'TextColor',
  HighlightText = 'HighlightText',
  IndentIncrease = 'IndentIncrease',
  IndentDecrease = 'IndentDecrease',
  ColumnVertical1 = 'ColumnVertical1',
  ColumnVertical2 = 'ColumnVertical2',
  ColumnVertical3 = 'ColumnVertical3',
  Plus = 'Plus',
  BrowserCode = 'BrowserCode',
  Code4 = 'Code4',
  CoverImage = 'CoverImage',
  Data = 'Data',
  Divider = 'Divider',
  ImageAdd = 'ImageAdd',
  LinkAngled = 'LinkAngled',
  Menu2 = 'Menu2',
  Table = 'Table',
  Mention = 'Mention',
  AddElements = 'AddElements',
}

const BlazeIcons: { [key in IconName]: Icon } = {
  [IconName.NormalText]: NormalText,
  [IconName.Title]: Title,
  [IconName.H1]: H1,
  [IconName.H2]: H2,
  [IconName.H3]: H3,
  [IconName.Edit]: Edit3,
  [IconName.List]: List,
  [IconName.Reset]: ArrowRotateLeft2,
  [IconName.Font]: Font,
  [IconName.FontWeight]: FontWeight,
  [IconName.FontSize]: LetterSpacing3,
  [IconName.ListNumbers]: ListNumbers,
  [IconName.CheckList]: CheckList,
  [IconName.ToggleBlock]: ToggleBlock,
  [IconName.AlignLeft]: AlignLeft,
  [IconName.AlignRight]: AlignRight,
  [IconName.AlignCenter]: AlignCenter,
  [IconName.AlignJustify]: AlignJustify,
  [IconName.TextColor]: TextColor,
  [IconName.HighlightText]: HighlightText,
  [IconName.IndentIncrease]: IndentIncrease,
  [IconName.IndentDecrease]: IndentDecrease,
  [IconName.ColumnVertical1]: ColumnVertical1,
  [IconName.ColumnVertical2]: ColumnVertical2,
  [IconName.ColumnVertical3]: ColumnVertical3,
  [IconName.Plus]: Plus,
  [IconName.BrowserCode]: BrowserCode,
  [IconName.Code4]: Code4,
  [IconName.CoverImage]: CoverImage,
  [IconName.Data]: Data,
  [IconName.Divider]: Divider,
  [IconName.ImageAdd]: ImageAdd,
  [IconName.LinkAngled]: LinkAngled,
  [IconName.Menu2]: Menu2,
  [IconName.Table]: Table,
  [IconName.Mention]: Mention,
  [IconName.AddElements]: AddElements,
}

interface Props {
  name: IconName
  size?: number
}

export const ToolbarIcon = ({ name, ...rest }: Props) => {
  const Component = BlazeIcons[name]

  return <Component {...rest} />
}
